import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import userImage from '../assets/img/email.png';

/**
 *
 */

const errStyle = {
    color: 'red',
    fontSize: '14',
    textAlign: 'center'
};

class Verify extends Component {
    constructor(props){
        super(props);

        let urlParams = this.props.location.search.replace('?', '').split('&');
        let params = {};
        for(let i = 0; i < urlParams.length; i++){
            let split_params = urlParams[i].split('=');
            params[split_params[0]] = split_params[1];
        }

        this.state = {
            email: '',
            password: '',
            params: params
        }
    }

    componentDidMount(){
        if(this.state.params.access_token){
            //this.props.checkResetToken(this.state.params.access_token);
        }
        this.props.hideLoader();
        if(this.props.match.params.token){
            let email = '';
            if(this.props.match.params.email){
                email = this.props.match.params.email;
            }else if(this.props.user){
                if(this.props.user.user.email){
                    email = this.props.user.user.email;
                }
            }
            
            if(email){
                this.props.verifyWithCode(this.props.user.user, this.props.match.params.token, email);
            }
        }
    }

    componentWillUnmount(){
        this.props.resetPasswordStatus();
    }

    sendPasswordReset(e){
        e.preventDefault();
        this.props.authClear();
        this.props.requestPasswordReset(this.state.email);
    }

    resetPassword(e){
        e.preventDefault();
        this.props.authClear();
        this.props.resetPassword(this.state.params.access_token, this.state.password);
    }
    render(){

        let urlParams = this.props.location.search.replace('?', '').split('&');
        let params = {};
        for(let i = 0; i < urlParams.length; i++){
            let split_params = urlParams[i].split('=');
            params[split_params[0]] = split_params[1];
        }

        if(this.props.passwordResetCompleted){
            return (
                <div className="app app-header-fixed loginSignupPage">
                    <div className="container w-xxl w-auto-xs sm-bottom50" >
                        <h3 className="font-100 sm-top100 sm-bottom50 text-center">
                            Reset Your Password
                        </h3>
                        <div>
                            Your password has been reset successfully.  You may now log in.
                        </div>
                        <div className="text-center">
                            <Link to={'/login'} className="btn btn-lg btn-default btn-block">Login now</Link>
                        </div>
                        <p className="text-center sm-bottom50"></p>
                    </div>
                </div>
            )
        }


        return (
            <div className="app app-header-fixed loginSignupPage">
                <div className="container w-xxl w-auto-xs sm-bottom50" >
                    <h3 className="font-100 sm-top100 sm-bottom50 text-center">
                        Verify your account
                    </h3>

                    {(this.state.params.access_token) ?
                        <div>

                            <div className="lockscreen-item">
                                <div className="lockscreen-image">
                                    <img src={userImage} alt="User" />
                                </div>
                                <form className="lockscreen-credentials" onSubmit={e => this.resetPassword(e)}>
                                    <div className="input-group">
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder="New Password"
                                            value={this.state.password}
                                            onChange={(e) => this.setState({password: e.target.value})}
                                        />
                                        <div className="input-group-btn">
                                            <button className="btn">
                                                <i className="fa fa-arrow-right text-muted"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="help-block text-center">
                                Enter a new password.
                            </div>
                            <div className="text-center">
                                <Link to={'/signup'}>Or sign in as a different user</Link>
                            </div>
                        </div>
                        :


                    (this.props.message) ?
                        <div>
                            <div className="help-block text-center">
                                {this.props.message}
                            </div>
                        </div>
                        :

                    <div>

                        <div className="">
                            <div className=" text-center">
                                <img src={userImage} alt="User" className="avatar center" />
                            </div>
                            
                        </div>
                        <div className="help-block text-center">
                            <div>
                                {this.props.codeWrong ?
                                    <span className="text-danger">Verification code not valid</span>
                                    
                                    :
                                    this.props.codeSent ?
                                    <span className="text-success">Verification code sent</span>
                                    :
                                    null
                                }
                            </div>
                            <div>
                                {this.props.codeSent ?
                                    
                                    null
                                :
                                    <button onClick={e => {e.preventDefault; this.props.sendToken(this.props.user.user, this.props.user.id)}} className="btn btn-primary">Re-send Verification Email</button>
                                
                                }
                            </div>
                            <br /><br />
                            <p>We’ve just sent you a verification email at {this.props.user.user.email}!</p>
                            <p>It can sometimes take up to 30 minutes to receive this email. 
                                However, in the event that you still don’t see it in your inbox, please check your spam folder, and if it still doesn’t show up then contact your instructor.</p>  

                        </div>
                        {
                            this.props.passwordResetError &&
                            <div style={errStyle}>{this.props.passwordResetError} <p className="text-center sm-bottom30"></p></div>
                        }
                        <div className="text-center">
                            <Link to={'/login'}>Or sign in as a different user</Link>
                        </div>
                    </div>
                    }
                    <p className="text-center sm-bottom100"></p>
                </div>
            </div>

        )
    }
}

export default Verify;


// WEBPACK FOOTER //
// ./src/components/Verify.js